import React from 'react';
import SvgContainer from './styled';

interface Props {
  Icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  width?: number;
  height?: number;
  className?: string;
}

const IconSvg: React.FC<Props> = (props) => {
  const { Icon } = props;
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <SvgContainer {...props}>
      <Icon />
    </SvgContainer>
  );
};

export default IconSvg;
